export class CasePrintDocument {
  name: string;
  type: string;
  url: string;
}
